import {
  Avatar,
  Box,
  Card,
  CardContent,
  Divider,
  Typography,
} from "@mui/material";
import GoldTrophy from "../../../../images/GoldTrophy.svg";
import SilverTrophy from "../../../../images/SilverTrophy.svg";
import BronzeTrophy from "../../../../images/BronzeTrophy.svg";

const BasicUsersLeaderboard = ({ topusers }) => {
  const top3 = topusers.slice(0, 3);
  const remaining = topusers.slice(3, 6);

  const trophyImages = [GoldTrophy, SilverTrophy, BronzeTrophy];
  const avatarTextColors = ["#C49000", "#0097A7", "#C2185B"];
  const avatarColors = ["#FBC02D", "#4DD0E1", "#F06292"];

  return (
    <Card
      sx={{
        backgroundColor: "#F8F9FF",
        borderRadius: "12px",
        boxShadow: `4px 4px 10px #A4A4A44D, -4px -4px 10px #A4A4A44D`,
        p: { xs: 1.5, md: 2 },
        minHeight: 350,
        maxHeight: { xs: "auto", md: 400 },
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
      }}
    >
      <CardContent sx={{ p: 0 }}>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
            Top Users
          </Typography>
        </Box>

        <Divider
          sx={{
            mt: 1,
            mb: 2,
            width: "100%",
            borderColor: "#e0e0e0",
          }}
        />

        {/* Top 3 Users with Trophies */}
        {top3.map((user, index) => (
          <Box
            key={user.display_name}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "85%",
              px: 2,
              py: 1.2,
              my: 1,
              mx: "auto",
              backgroundColor: "#f9f9fb",
              border: "1px solid #e0e0e0",
              borderRadius: "8px",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <img
                src={trophyImages[index]}
                alt="Trophy"
                style={{ width: 20, height: 30 }}
              />
              <Avatar
                sx={{
                  width: 28,
                  height: 28,
                  bgcolor: avatarColors[index],
                  color: avatarTextColors[index],
                  fontSize: "13px",
                  fontWeight: "bold",
                }}
              >
                {user.display_name[0]}
              </Avatar>
              <Typography
                variant="body2"
                sx={{ fontWeight: "bold", fontSize: "14px", color: "#000" }}
              >
                {user.display_name}
              </Typography>
            </Box>
            <Typography
              variant="body2"
              sx={{ fontWeight: "bold", fontSize: "14px", color: "#000" }}
            >
              {Math.floor(user.tokens_used / 100)} pts
            </Typography>
          </Box>
        ))}

        <Divider sx={{ mt:3, borderColor: "#e0e0e0" }} />

        {/* Remaining Users */}
        {remaining.map((user, index) => (
          <Box key={user.display_name}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                px: 10,
                py: 1.2,
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Avatar
                  sx={{
                    width: 24,
                    height: 24,
                    bgcolor: avatarColors[index],
                    color: avatarTextColors[index],
                    fontSize: "12px",
                    fontWeight: "bold",
                  }}
                >
                  {user.display_name[0]}
                </Avatar>
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: 500,
                    fontSize: "14px",
                    color: "#7b7272ff",
                  }}
                >
                  {user.display_name}
                </Typography>
              </Box>
              <Typography
                variant="body2"
                sx={{ fontWeight: "bold", fontSize: "14px", color: "#848282ff" }}
              >
                {Math.floor(user.tokens_used / 100)} pts
              </Typography>
            </Box>
            <Divider sx={{ borderColor: "#e0e0e0", mx: 0 }} />
          </Box>
        ))}
      </CardContent>
    </Card>
  );
};

export default BasicUsersLeaderboard;
